import { createApiFactory, createPlugin, createRoutableExtension, discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';
import { EpDevPPluginIds } from '@solace-labs/backstage-plugin-ep-devp-common';
import { EpDevPConsumerAppsApiClient } from './APIplugins/ep-devp-consumer-apps-common';
import { EpDevPConsumerProductsApiClient } from '@solace-labs/backstage-plugin-ep-devp-consumer-products-common';
import { epDevPConsumerAppsApiRef, epDevPConsumerProductsApiRef } from './api';
import { rootRouteRef } from './routes';

/** @public */
export const epDevPConsumerAppsPlugin = createPlugin({
  id: EpDevPPluginIds.EpDevPConsumerAppsPluginId,
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: epDevPConsumerAppsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new EpDevPConsumerAppsApiClient({
          discoveryApi: discoveryApi,
          fetchApi: fetchApi
        }),
    }),
    createApiFactory({
      api: epDevPConsumerProductsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new EpDevPConsumerProductsApiClient({
          discoveryApi: discoveryApi,
          fetchApi: fetchApi
        }),
    }),
  ]
});

/** @public */
export const EpDevPConsumerAppsPage = epDevPConsumerAppsPlugin.provide(
  createRoutableExtension({
    name: 'EpDevPConsumerAppsPage',
    component: () =>
      import('./Router').then(m => m.Router),
    mountPoint: rootRouteRef,
  }),

);
